import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";

const SalesOrderInsights = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [sorting, setSorting] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/sales-order",
        endpoint: "/api/sales-order/",
    });

    const { data, isFetching, isError } = useFetch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
            sort_q:
                sorting &&
                sorting
                    ?.map((item) => (item?.desc ? "desc" : "asc"))
                    ?.join(","),
            sort_c: sorting && sorting?.map((item) => item?.id)?.join(","),
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: true,
        staleTime: 300000,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const columns = [
        {
            accessor: "so_number",
            header: "Sales Order number",
            cell: (row) => {
                return (
                    <span
                        style={{ cursor: "pointer", fontWeight: "bold" }}
                        onClick={() => {
                            if (
                                privileges?.includes(
                                    "sales_order_insights_detail"
                                )
                            ) {
                                navigate("/sales-order-insights-detail", {
                                    state: { data: row },
                                });
                            }
                        }}
                    >
                        {row?.so_number}
                    </span>
                );
            },
            filterable: true,
            columnWidth: 150,
        },
        {
            accessor: "created_at",
            header: "Created On",
            cell: (row) => (
                <>
                    {row?.created_at
                        ? moment(row?.created_at).format("DD-MM-YYYY HH:mm")
                        : "--"}
                </>
            ),
            // sortable: true,
            columnWidth: 130,
        },
        {
            accessor: "created_by",
            header: "Created by",
            filterable: true,
        },
        {
            accessor: "client",
            header: "Client Name",
            cell: (row) => (
                <>
                    {row?.client?.user?.first_name +
                        " " +
                        row?.client?.user?.last_name}
                </>
            ),
            filterable: true,
            columnWidth: 250,
        },
        {
            accessor: "product",
            header: "Product Name",
            cell: (row) => <>{row?.product?.item_name}</>,
            filterable: true,
            columnWidth: 150,
        },
        {
            accessor: "product",
            header: "Product ID",
            cell: (row) => <>{row?.product?.item_code}</>,
            columnWidth: 100,
        },
        {
            accessor: "target_date",
            header: "Target Date",
            cell: (row) => <>{moment(row?.target_date).format("DD-MM-YYYY")}</>,
            // sortable: true,
            columnWidth: 120,
        },
        {
            accessor: "dispatch_location",
            header: "Dispatch Location",
            filterable: true,
        },
        {
            accessor: "quantity",
            header: "Quantity",
        },
    ].filter(Boolean);

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handleSortingChnage = (value) => {
        console.log(value);
        setSorting(value);
    };

    const handlePagination = (value) => {
        console.log(value);
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    if (isError) return <div>Error loading data.</div>;

    return (
        <div>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Sales Order Insights
                        </h3>
                    </div>
                </div>
            </div>
            <Table
                data={data ? data?.results?.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={data ? data?.count : 0}
                isLoading={isFetching}
                globalSearch
                editRows={false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onPaginationChange={handlePagination}
                onSortingChange={handleSortingChnage}
            />
        </div>
    );
};

export default SalesOrderInsights;
